import { render, staticRenderFns } from "./Quadrants.vue?vue&type=template&id=abbe7c10&scoped=true"
import script from "./Quadrants.vue?vue&type=script&lang=js"
export * from "./Quadrants.vue?vue&type=script&lang=js"
import style0 from "./Quadrants.vue?vue&type=style&index=0&id=abbe7c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbe7c10",
  null
  
)

export default component.exports